module.exports = __webpack_public_path__ + "static/media/backgroundSP.beeaee6d.png";